import React, { useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FeeDetailsTable from '../components/feedetailstable/FeeDetailsTable';
import {
  addPenalityAmount,
  getAcademicYears,
  getStudentsDetailsByBranch,
  resetAcademicDetailsState,
  resetPenalityDetails,
  updateStudentDetails,
} from '../redux/features/student/studentSlice';
import StudentDetailsModal from '../modals/studentDetailsModal/StudentDetailModal';
import Header from '../components/header/Header';
import { AiOutlineSearch } from 'react-icons/ai';
import useToast from '../shared/Toast';
import { Spinner } from 'react-bootstrap';
import OfflinePaymentModal from '../modals/offlinePaymentModal/OfflinePaymentModal';
import DownloadPdfModal from '../modals/downloadPdfModal/DownloadPdfModal';
import AppContext from '../storage/AppContext';
import XLSX from 'xlsx';
import FileSaver from 'file-saver';
import AddDiscountModal from '../modals/addDiscountModal/AddDiscountModal';
import { BiFilter, BiSelectMultiple } from 'react-icons/bi';
import { MdClear } from 'react-icons/md';
import FiltersModal from '../modals/filtersModal/FiltersModal';
import ChequeOrDDModal from '../modals/chequeOrDDModal/ChequeOrDDModal';
import LabelsModal from '../modals/labelsModal/LabelsModal';
import AddPenalityModal from '../modals/AddPenalityModal/AddPenalityModel';

function ViewStudentDetailsContainer() {
  const studentsDetails = useSelector(
    (state) => state?.student?.allStudentsDetails
  );
  const [showModal, setShowModal] = useState(false);
  const [showOfflineModal, setShowOfflineModal] = useState(false);
  const [editStudent, setEditStudent] = useState('');
  const [offlinePaymentDetails, setOfflinePaymentDetails] = useState({});
  const [term, setTerm] = useState('');
  const [amount, setAmount] = useState(0);
  const [discountAmount, setDiscountAmount] = useState('');
  const [showDownloadPdfModal, setShowDownloadPdfModal] = useState(false);
  const [downloadPdfModalDetails, setDownloadPdfModalDetails] = useState({});
  const [showChequeOrDDModal, setShowChequeOrDDModal] = useState(false);
  const [chequeOrDDModalDetails, setChequeOrDDModalDetails] = useState({});
  const [showAddDiscountModal, setShowAddDiscountModal] = useState(false);
  const [addDiscountModalDetails, setAddDiscountModalDetails] = useState([]);

  const [showAddPenalityModal, setShowAddPenalityModal] = useState(false);
  const [addPenalityModalDetails, setAddPenalityModalDetails] = useState([]);

  const [showFiltersModal, setShowFiltersModal] = useState(false);
  const [allValues, setAllValues] = useState(editStudent);
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [showLabelsModal, setShowLabelsModal] = useState(false);
  const [selectedAcademicYear, setAcademicYear] = useState('');

  const [columns, setColumns] = useState([]);
  const [renamedFields, setRenamedFields] = useState([]);
  const [termFees, setTermFees] = useState([]);

  const appContext = useContext(AppContext);

  const userDetails = appContext?.userDetails;

  const showToast = useToast();

  const dispatch = useDispatch();

  const feeRef = useRef(null);

  const onChangeSearchInput = (e) => {
    feeRef?.current?.setFilter(e.target.value);
  };

  const academicData = useSelector((state) => state.student.academicDetails);
  const updatedStudentDetails = useSelector(
    (state) => state.student.updateStudentDetails
  );

  const discountApprovalDetails = useSelector(
    (state) => state.student.sendForApprovalDetails
  );

  const penalityDetails = useSelector(
    (state) => state?.student?.addPenalityAmountDetails
  );

  console.log('penalityDetails', penalityDetails);

  useEffect(() => {
    if (academicData.status === 'succeeded') {
      const academicYear = academicData?.data?.filter(
        (each) => each.isCurrentYear === true
      )[0]?.academicYear;
      setAcademicYear(academicYear);
    } else if (academicData.status === 'failed') {
      showToast({ message: academicData.error, type: 'error' });
    }
  }, [academicData.status]);

  useEffect(() => {
    if (updatedStudentDetails.status === 'succeeded') {
      dispatch(
        getStudentsDetailsByBranch({ branch: userDetails?.data?.branch, academicYear: selectedAcademicYear })
      );
      showToast({ message: updatedStudentDetails.message });
    }
    if (updatedStudentDetails.status === 'failed') {
      showToast({ message: updatedStudentDetails.error, type: 'error' });
    }
  }, [updatedStudentDetails]);

  useEffect(() => {
    if (discountApprovalDetails.status === 'succeeded') {
      setTimeout(() => {
        window.location.reload();
      }, 2500);
      showToast({ message: discountApprovalDetails.message });
    }
    if (discountApprovalDetails.status === 'failed') {
      showToast({ message: discountApprovalDetails.message, type: 'error' });
    }
  }, [discountApprovalDetails]);

  useEffect(() => {
    dispatch(getStudentsDetailsByBranch({ branch: userDetails?.data?.branch }));
    dispatch(getAcademicYears());
  }, []);

  useEffect(() => {
    if (studentsDetails?.status === 'succeeded') {
      setFilteredStudents(studentsDetails?.data);
    } else if (studentsDetails?.status === 'failed') {
      showToast({ message: studentsDetails.error, type: 'error' });
    }
  }, [studentsDetails.status]);

  const setColumnAndDataValues = () => {
    const c = [
      {
        Header: 'Name',
        accessor: 'NAME',
      },
      {
        Header: 'Email',
        accessor: 'e-mail',
      },
      {
        Header: 'Phone Number',
        accessor: 'Phone number',
      },
      {
        Header: 'Admission Number',
        accessor: 'ADMISSION',
      },
      {
        Header: 'Class',
        accessor: 'Class',
      },
      {
        Header: 'Section',
        accessor: 'Section',
      },
      {
        Header: 'Roll No',
        accessor: 'Roll No',
      },
    ];
    const termFeesDetails = [];
    const renameFields = [];

    for (let studentDetail of filteredStudents) {
      let termFee = {};
      studentDetail.termFee.map((eachTerm) => {
        let key = Object.keys(eachTerm)?.[0];
        let status = key.replace('Fee', 'Status');
        let discount = key.replace('Fee', 'Discounted Amount');
        if (
          !termFeesDetails.includes(key) &&
          (key !== '__v' || key !== '_id')
        ) {
          termFeesDetails.push(key);
        }
        termFee[key] = eachTerm[key].amount;
        termFee[discount] =
          eachTerm[key].discountedAmount &&
          eachTerm[key].discountedAmount !== 'NA'
            ? eachTerm[key].discountPercentage
              ? eachTerm[key].discountedAmount +
                ' (' +
                eachTerm[key].discountPercentage +
                '%)'
              : eachTerm[key].discountedAmount
            : 'NA';
        termFee[status] = eachTerm[key].paymentStatus;
      });

      let fields = {
        NAME: studentDetail.name,
        'e-mail': studentDetail.email,
        'Phone number': studentDetail.phoneNumber,
        ADMISSION: studentDetail.admissionNumber,
        Class: studentDetail.class,
        Section: studentDetail.section,
        'Roll No': studentDetail.rollNo,
        ...termFee,
      };
      renameFields.push(fields);
    }

    setRenamedFields(renameFields);
    setTermFees(termFeesDetails);

    for (let termFee of termFeesDetails.sort()) {
      if (termFee !== 'undefined') {
        c.push(
          {
            Header: termFee,
            accessor: termFee,
          },
          {
            Header: termFee.replace('Fee', 'Amount After Discount'),
            accessor: termFee.replace('Fee', 'Discounted Amount'),
          },
          {
            Header: termFee.replace('Fee', 'Status'),
            accessor: termFee.replace('Fee', 'Status'),
          }
        );
      }
    }

    c.push({
      Header: 'Action',
      accessor: 'Action',
    });
    setColumns(c);
  };

  useEffect(() => {
    if (filteredStudents.length > 0) {
      setColumnAndDataValues();
    }
  }, [filteredStudents]);

  useEffect(() => {
    if (penalityDetails.status === 'succeeded') {
      showToast({ message: penalityDetails.message });
      dispatch(
        getStudentsDetailsByBranch({
          branch: addPenalityModalDetails.branch,
          academicYear: addPenalityModalDetails.selectedAcademicYear,
        })
      );
      setShowAddPenalityModal(false);
    } else if (penalityDetails.status === 'failed') {
      showToast({ message: penalityDetails.error, type: 'error' });
    }
  }, [penalityDetails.status]);

  const updateStudent = (data) => {
    if (Object.keys(offlinePaymentDetails).length > 0) {
      Object.keys(offlinePaymentDetails).map((key) => {
        Object.keys(data.termFeeDetails).map((key1) => {
          if (key === key1.replace(' Fee', '')) {
            data.termFeeDetails[key1].offlineDetails =
              offlinePaymentDetails[key];
            data.termFeeDetails[key1].paidAmount =
              offlinePaymentDetails[key].amountPaid;
          }
        });
      });
    }
    dispatch(updateStudentDetails({ data, branch: userDetails?.data?.branch, academicYear: selectedAcademicYear }));
  };

  const onBtnExport = () => {
    // import("xlsx").then((xlsx) => {
    const exportDetails = [];
    for (let studentDetail of filteredStudents) {
      let termFee = {};
      studentDetail.termFee.map((eachTerm) => {
        let key = Object.keys(eachTerm)?.[0];
        let status = key.replace('Fee', 'Status');
        let discount = key.replace('Fee', 'Discounted Amount');
        let paidDate = key.replace('Fee', 'Paid Date');
        termFee[key] = eachTerm[key].amount;
        termFee[discount] =
          eachTerm[key].discountedAmount &&
          eachTerm[key].discountedAmount !== 'NA'
            ? eachTerm[key].discountPercentage
              ? eachTerm[key].discountedAmount +
                ' (' +
                eachTerm[key].discountPercentage +
                '%)'
              : eachTerm[key].discountedAmount
            : 'NA';
        termFee[status] = eachTerm[key].paymentStatus;

        if (eachTerm[key].date) {
          const fullDate = new Date(eachTerm[key].date);
          const date = ('0' + fullDate.getDate()).slice(-2);
          const month = ('0' + (fullDate.getMonth() + 1)).slice(-2);
          const year = fullDate.getFullYear();
          termFee[paidDate] = `${date}-${month}-${year}`;
        } else {
          termFee[paidDate] = 'NA';
        }
      });

      let fields = {
        NAME: studentDetail.name,
        'e-mail': studentDetail.email,
        'Phone number': studentDetail.phoneNumber,
        ADMISSION: studentDetail.admissionNumber,
        Class: studentDetail.class,
        Section: studentDetail.section,
        'Roll No': studentDetail.rollNo,
        ...termFee,
      };
      exportDetails.push(fields);
    }

    // console.log("exportDetails",exportDetails,"renamedFields",renamedFields,"studentsDetails",studentsDetails,"filteredStudents",filteredStudents)
    const worksheet = XLSX.utils.json_to_sheet(exportDetails);
    const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });
    saveAsExcelFile(excelBuffer, 'StudentsData');
    // });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    // import("file-saver").then((FileSaver) => {
    let EXCEL_TYPE =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
    );
    // });
  };

  const onClickAddDiscount = () => {
    setAddDiscountModalDetails(termFees);
    setShowAddDiscountModal(true);
  };

  const onAddPenality = () => {
    setAddPenalityModalDetails({
      selectedAcademicYear,
      termFees,
      branch: userDetails?.data?.branch,
    });
    setShowAddPenalityModal(true);
  };

  const dispatchPenality = (data) => {
    dispatch(addPenalityAmount(data));
  };

  const onClickAddFilters = () => {
    setShowFiltersModal(true);
  };

  const onClickClearFliters = () => {
    setFilteredStudents(studentsDetails.data);
  };

  const onClickSelectLabels = () => {
    setShowLabelsModal(true);
  };

  const onChangeAcademicYear = (e) => {
    setAcademicYear(e.target.value);
    dispatch(
      getStudentsDetailsByBranch({
        branch: userDetails?.data?.branch,
        academicYear: e.target.value,
      })
    );
  };

  return (
    <div>
      <Header />

      {penalityDetails.status === 'loading' ||
      academicData.status === 'loading' ||
      studentsDetails.status === 'loading' ? (
        <div
          style={{ minHeight: '80vh' }}
          className='d-flex justify-content-center align-items-center'
        >
          <Spinner animation='border' role='status'></Spinner>
        </div>
      ) : (
        <div className='p-2' style={{ overflow: 'auto' }}>
          {filteredStudents.length === 0 && selectedAcademicYear !== '' && (
            <div>
              <label className='control-label' htmlFor='year'>
                Academic Year
              </label>
              <select
                style={{ backgroundImage: 'none', width: '25%' }}
                value={selectedAcademicYear}
                onChange={onChangeAcademicYear}
                className='form-control'
                id='year'
                name='year'
                required
              >
                {academicData?.data?.map((eachYear) => {
                  return (
                    <option value={eachYear.academicYear}>
                      {eachYear.academicYear}
                    </option>
                  );
                })}
              </select>
            </div>
          )}
          {filteredStudents.length !== 0 && (
            <div className='d-flex align-items-center mb-3 mt-2'>
              <button
                onClick={onBtnExport}
                style={{
                  backgroundColor: '#0b54ab',
                  alignSelf: 'center',
                  height: '40px',
                  width: '150px',
                  padding: '2px',
                  borderRadius: '5px',
                  color: '#ffffff',
                  border: 'none',
                  fontWeight: '500',
                  fontSize: '16px',
                  marginRight: '5px',
                }}
              >
                Export As Excel
              </button>
              {userDetails?.data?.role === 'Admin' && (
                <button
                  onClick={onAddPenality}
                  style={{
                    backgroundColor: '#0b54ab',
                    alignSelf: 'center',
                    height: '40px',
                    width: '150px',
                    padding: '2px',
                    borderRadius: '5px',
                    color: '#ffffff',
                    border: 'none',
                    fontWeight: '500',
                    fontSize: '16px',
                    marginRight: '5px',
                  }}
                >
                  Add Penality
                </button>
              )}

              {(userDetails?.data?.role === 'OpsAdmin' ||
                userDetails?.data?.role === 'FinAdmin') 
                && (
                  <button
                    onClick={onClickAddDiscount}
                    style={{
                      backgroundColor: '#0b54ab',
                      alignSelf: 'center',
                      height: '40px',
                      width: '150px',
                      padding: '2px',
                      borderRadius: '5px',
                      color: '#ffffff',
                      border: 'none',
                      fontWeight: '500',
                      fontSize: '16px',
                    }}
                  >
                    Add Discount
                  </button>
                )}

              {selectedAcademicYear !== '' && (
                <div className='ml-2'>
                  <select
                    style={{ backgroundImage: 'none' }}
                    value={selectedAcademicYear}
                    onChange={onChangeAcademicYear}
                    className='form-control'
                    id='year'
                    name='year'
                    required
                  >
                    {academicData?.data?.map((eachYear) => {
                      return (
                        <option value={eachYear.academicYear}>
                          {eachYear.academicYear}
                        </option>
                      );
                    })}
                  </select>
                </div>
              )}

              <div
                className='d-flex align-items-center ml-auto mr-3'
                style={{ color: '#0b54ab', cursor: 'pointer' }}
                onClick={onClickSelectLabels}
              >
                <BiSelectMultiple size={20} className='mr-1' />
                <p className='m-0'>Select labels</p>
              </div>
              <LabelsModal
                showLabelsModal={showLabelsModal}
                setShowLabelsModal={setShowLabelsModal}
                columns={columns}
                setColumns={setColumns}
              />

              <div
                className='d-flex align-items-center mr-3'
                style={{ color: '#0b54ab', cursor: 'pointer' }}
                onClick={onClickAddFilters}
              >
                <BiFilter size={20} />
                <p className='m-0'>Add Filters</p>
              </div>
              <FiltersModal
                setFilteredStudents={setFilteredStudents}
                filtersModalDetails={studentsDetails}
                showFiltersModal={showFiltersModal}
                setShowFiltersModal={setShowFiltersModal}
              />

              {filteredStudents.length !== studentsDetails?.data.length && (
                <div
                  className='d-flex align-items-center mr-3'
                  style={{ color: '#0b54ab', cursor: 'pointer' }}
                  onClick={onClickClearFliters}
                >
                  <MdClear size={20} />
                  <p className='m-0'>Clear Filters</p>
                </div>
              )}

              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '10px',
                  width: '25%',
                  border: '1px solid #d6d6d6',
                  borderRadius: '5px',
                  backgroundColor: '#ffffff',
                  marginRight: '5px',
                }}
              >
                <AiOutlineSearch size={20} />
                <input
                  type='search'
                  style={{
                    marginLeft: '5px',
                    border: 'none',
                    outline: 'none',
                    width: '100%',
                  }}
                  placeholder='Search'
                  onChange={(e) => onChangeSearchInput(e)}
                />
              </div>
            </div>
          )}

          <StudentDetailsModal
            allValues={allValues}
            setAllValues={setAllValues}
            showOfflineModal={showOfflineModal}
            setShowOfflineModal={setShowOfflineModal}
            showModal={showModal}
            setShowModal={setShowModal}
            editStudent={editStudent}
            updateStudent={updateStudent}
            setTerm={setTerm}
            setAmount={setAmount}
            setDiscountAmount={setDiscountAmount}
          />
          <OfflinePaymentModal
            allValues={allValues}
            setAllValues={setAllValues}
            offlinePaymentDetails={offlinePaymentDetails}
            term={term}
            amount={amount}
            discountAmount={discountAmount}
            showOfflineModal={showOfflineModal}
            setShowOfflineModal={setShowOfflineModal}
            setOfflinePaymentDetails={setOfflinePaymentDetails}
          />
          <DownloadPdfModal
            downloadPdfModalDetails={downloadPdfModalDetails}
            showDownloadPdfModal={showDownloadPdfModal}
            setShowDownloadPdfModal={setShowDownloadPdfModal}
          />
          <ChequeOrDDModal
            chequeOrDDModalDetails={chequeOrDDModalDetails}
            showChequeOrDDModal={showChequeOrDDModal}
            setShowChequeOrDDModal={setShowChequeOrDDModal}
          />
          <AddDiscountModal
            selectedAcademicYear={selectedAcademicYear}
            addDiscountModalDetails={addDiscountModalDetails}
            showAddDiscountModal={showAddDiscountModal}
            setShowAddDiscountModal={setShowAddDiscountModal}
          />
          <AddPenalityModal
            dispatchPenality={dispatchPenality}
            addPenalityModalDetails={addPenalityModalDetails}
            showAddPenalityModal={showAddPenalityModal}
            setShowAddPenalityModal={setShowAddPenalityModal}
          />
          {filteredStudents.length !== 0 ? (
            <FeeDetailsTable
              selectedAcademicYear={selectedAcademicYear}
              academicData={academicData}
              ref={feeRef}
              studentsData={filteredStudents}
              columns={columns}
              data={renamedFields}
              setShowModal={setShowModal}
              setEditStudent={setEditStudent}
              setShowDownloadPdfModal={setShowDownloadPdfModal}
              setDownloadPdfModalDetails={setDownloadPdfModalDetails}
              setShowChequeOrDDModal={setShowChequeOrDDModal}
              setChequeOrDDModalDetails={setChequeOrDDModalDetails}
            />
          ) : (
            <h1 className='d-flex justify-content-center align-items-center'>
              No Records Found
            </h1>
          )}
        </div>
      )}
    </div>
  );
}

export default ViewStudentDetailsContainer;
